export default "__VITE_ASSET__CRFNagr8__"